export const createRecordWithType =
  <V>() =>
  <T extends Record<string, V>>(o: T) => {
    return o;
  };
